(function( $, window, document, undefined) {
    var FixedSellBoxSmall = {
        init: function init(elem, options) {
            this.$box = $( elem );
            this.$curriculum = $('.curriculum-author');
            this.options = options;

            this.events();
        },

        handleScroll: function handleScroll() {
            var scrolledAmount = $(window).scrollTop();
            var isFreePage = this.options.freePage ? 100 : this.$curriculum.offset().top

            if( scrolledAmount >= isFreePage && this.$box ) {
                this.$box.addClass( 'is-active' );
            } else {
                this.$box.removeClass( 'is-active' );
            }
        },

        events: function events() {
            window.addEventListener('scroll', this.handleScroll.bind(this));
        }
    };

    $.fn.fixedSellBoxSmall = function( options ) {
        return this.each(function() {
            var fixedSellBoxSmall = Object.create( FixedSellBoxSmall );
            fixedSellBoxSmall.init(this, options);
        });
    };

})( jQuery, window, document );
